export const defaulLeague = [
  {
    league: {
      id: 116,
      name: "NCAA",
      type: "League",
      season: "2024-2025",
      logo: "https://media.api-sports.io/basketball/leagues/116.png",
    },
    country: {
      id: 5,
      name: "USA",
      code: "US",
      flag: "https://media.api-sports.io/flags/us.svg",
    },
  },
];
